import { navigationActions } from '../core/navigation/navigationSlice.js';
import { initSourceDataByCustomEvent } from '../core/sourceData/thunks.js';
import { addDynamicGlobalTrackingLibraryScript } from '../tools/tracking.js';
import { modalNavigationMiddleware } from '../wrappers/Modal/modalNavigationMiddleware.js';
import { pageNavigationMiddleware } from '../wrappers/Page/pageNavigationMiddleware.js';
export const initCommonModalsDependencies = (encodedGTLibraryUrl, dispatch, payload) => {
    pageNavigationMiddleware.pause();
    modalNavigationMiddleware.add();
    addDynamicGlobalTrackingLibraryScript(encodedGTLibraryUrl);
    dispatch(initSourceDataByCustomEvent(payload));
    dispatch(navigationActions.setNavigationContext('modal'));
};
//# sourceMappingURL=initCommonModalsDependencies.js.map